import { cn, generateTextShadow } from "@/lib/utils";
import { type CSSProperties, useEffect, useState } from "react";

export default function AnimatedWaiting({
  prefix = "Waiting",
  className,
  style,
  useTextShadow = false,
  textShadowSize = 1.5,
}: {
  prefix?: string;
  className?: string;
  style?: CSSProperties;
  useTextShadow?: boolean;
  textShadowSize?: number;
}) {
  const [dots, setDots] = useState("");

  useEffect(() => {
    const frames = ["", ".", "..", "..."];
    let currentFrame = 0;

    const interval = setInterval(() => {
      currentFrame = (currentFrame + 1) % frames.length;
      setDots(frames[currentFrame]);
    }, 500); // Change every 500ms

    return () => clearInterval(interval);
  }, []);

  return (
    <p className={cn(className, "text-white/80")} style={style}>
      <span
        style={{
          ...(useTextShadow && { textShadow: generateTextShadow(textShadowSize) }),
        }}
      >
        {prefix}
      </span>
      <span
        style={{
          ...(useTextShadow && { textShadow: generateTextShadow(textShadowSize) }),
        }}
      >
        {dots}
      </span>
    </p>
  );
}
